import clsx from 'clsx'
import { navigate } from 'gatsby'
import { routes } from 'config'
import { Button } from 'components/common'

export const Error404 = (): JSX.Element => {
  return (
    <>
      <div className={clsx('text-center', 'mt-40')}>
        <h1 className={clsx('text-9xl', 'font-bold', 'mb-8')}>404</h1>
        <h2 className={clsx('text-3xl', 'font-bold', 'mb-6')}>Not Found</h2>
        <p>お探しのページが見つかりませんでした。</p>
        <Button
          type="link"
          onClick={(_e) => {
            navigate(routes.home)
          }}
        >
          ホームへ戻る
        </Button>
      </div>
    </>
  )
}
